import { Component } from '@angular/core';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-dashboard',
  templateUrl: './company-dashboard.component.html',
  styleUrls: ['./company-dashboard.component.scss']
})
export class CompanyDashboardComponent {
    HomeUrl: any;
    LoginDetails: any;
    countdata: any;

    constructor(public generalservice: GeneralService, private http: HttpClient,
        private router: Router) {
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
        });
        debugger
        this.LoginDetails = JSON.parse(localStorage.getItem("LoginDetails"));
    }
    ngOnInit() {
        this.appliedcount();

    }
    appliedcount() {
        var uploadfile = new FormData();
        uploadfile.append("Count", this.LoginDetails[0].RID);
        var url = "api/Njobs/Get_CompanyDashBoard_Count";
        this.generalservice.PostData(url, uploadfile).then(data => {
            debugger
            this.countdata = data;
        })
    }
}
